import { apiClient } from '@/lib/api';
export const sslAlertRulesApi = {
    get: () => apiClient.get('/sslwidewatch/ssl/alert-rules'),
    putDefault: (body) => apiClient.put('/sslwidewatch/ssl/alert-rules/default', body),
    putOverride: (domainId, body) => apiClient.put(`/sslwidewatch/ssl/alert-rules/domain/${domainId}`, body),
    removeOverride: (domainId) => apiClient.delete(`/sslwidewatch/ssl/alert-rules/domain/${domainId}`),
};
export const sslDeliveryLogApi = {
    /** Platform delivery-log, filtered client-side to SSL alert types. */
    list: (status, channel) => apiClient.get('/sslwidewatch/alerts/delivery-log', {
        query: {
            ...(status ? { status } : {}),
            ...(channel ? { channel } : {}),
        },
    }),
};
